<mat-card style="border-radius: 16px; overflow: hidden; max-width: 1200px; margin: auto;">
        <div style="display: flex; justify-content: center; flex-direction: column; align-items: center; width: 100%; margin-bottom: 48px;">
            <div style="display: flex; align-items: center; gap: 16px;">
                <img src="assets/img/logo_informax.png" alt="Logo" style="width: 200px;">
                <h1 style="font-weight: bold; color:#007fc7;">Evalúa y monitorea el riesgo de cualquier empresa</h1>
            </div>
             <mat-stepper [linear]="isLinear" #stepper>
                <mat-step [stepControl]="firstFormGroup">
                  <form [formGroup]="firstFormGroup">
                    <ng-template matStepLabel>Reportes</ng-template>
                    <div class="carousel-wrapper">
                        <div class="carousel-container">
                            <div class="carousel-img">
                                <img src="assets/img/img_reportes.png" alt="" style="width: 100px;">
                            </div>
                            <div class="carousel-content">
                                <div class="carousel-title">
                                    <h2 style="font-weight: bold;">Reportes</h2>
                                </div>
                                <div class="carousel-text">
                                    <p>Obtén de forma rápida y clara toda la información que necesitas para evaluar a una empresa: mercado en el que esta inserto, rangos de venta y patrimonio, comportamiento de pago, demandas, infracciones laborales y mucho más.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                  </form>
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" label="Flujo de crédito">
                    <div class="carousel-wrapper">
                        <div class="carousel-container">
                            <div class="carousel-img">
                                <img src="assets/img/img_flujo.png" alt="" style="width: 100px;">
                            </div>
                            <div class="carousel-content">
                                <div class="carousel-title">
                                    <h2 style="font-weight: bold;">Flujo de crédito</h2>
                                </div>
                                <div class="carousel-text">
                                    <p>Ingresa una solicitud de crédito y haz seguimiento de aquellas que estén en curso.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" label="Seguimiento de Cartera">
                    <div class="carousel-wrapper">
                        <div class="carousel-container">
                            <div class="carousel-img">
                                <img src="assets/img/img_cartera.png" alt="" style="width: 100px;">
                            </div>
                            <div class="carousel-content">
                                <div class="carousel-title">
                                    <h2 style="font-weight: bold;">Seguimiento de cartera</h2>
                                </div>
                                <div class="carousel-text">
                                    <p>Monitoreamos diariamente a tus clientes y proveedores. Te alertamos de cualquier cambio</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" label="Gestión de impagos">
                    <div class="carousel-wrapper">
                        <div class="carousel-container">
                            <div class="carousel-img">
                                <img src="assets/img/img_impagos.png" alt="" style="width: 100px;">
                            </div>
                            <div class="carousel-content">
                                <div class="carousel-title">
                                    <h2 style="font-weight: bold;">Seguimiento de cartera</h2>
                                </div>
                                <div class="carousel-text">
                                    <p>Acelera el pago de tus clientes morosos mediante la publicación y aclaración de impagos en el sistema financiero y comercial del país (Boletín Comercial, Equifax, TransUnion y Experian).</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-step>
              </mat-stepper>

                <div *ngIf="hasServiceErrors$ | async" class="alert-banner">
                    <div class="d-flex align-items-center justify-content-center flex-wrap">
                        <mat-icon class="mr-3 flex-shrink-0" fontSet="material-symbols-outlined">warning</mat-icon>
                        <h4>Estamos experimentando intermitencias en algunos servicios.</h4>
                        <a mat-button class="custom-link-button" [routerLink]="['estado-servicios']">
                            Ver estado de los servicios
                            <mat-icon iconPositionEnd class="icon-font flex-shrink-0">arrow_forward</mat-icon>
                        </a>
                    </div>
                </div>
        </div>
          
</mat-card>
